/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The configuration of the animatic for a gas sensor.
 */
export type AnimaticGasSensorConfig = {
  /**
   * The type of gas.
   */
  gasType: string;
};

/** @internal */
export const AnimaticGasSensorConfig$inboundSchema: z.ZodType<
  AnimaticGasSensorConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  gas_type: types.string(),
}).transform((v) => {
  return remap$(v, {
    "gas_type": "gasType",
  });
});
/** @internal */
export type AnimaticGasSensorConfig$Outbound = {
  gas_type: string;
};

/** @internal */
export const AnimaticGasSensorConfig$outboundSchema: z.ZodType<
  AnimaticGasSensorConfig$Outbound,
  z.ZodTypeDef,
  AnimaticGasSensorConfig
> = z.object({
  gasType: z.string(),
}).transform((v) => {
  return remap$(v, {
    gasType: "gas_type",
  });
});

export function animaticGasSensorConfigToJSON(
  animaticGasSensorConfig: AnimaticGasSensorConfig,
): string {
  return JSON.stringify(
    AnimaticGasSensorConfig$outboundSchema.parse(animaticGasSensorConfig),
  );
}
export function animaticGasSensorConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticGasSensorConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticGasSensorConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticGasSensorConfig' from JSON`,
  );
}
